import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, RotateCcw, Swords } from "lucide-react";
import DraftBoard from "../components/DraftBoard";
import SeasonResult from "../components/SeasonResult";
import { Toaster } from "../components/ui/toaster";
import AuthForm from "../components/AuthForm";
import { auth } from "../lib/api";

const Game = () => {
  const navigate = useNavigate();
  const [boardKey, setBoardKey] = useState(0);
  const [result, setResult] = useState(null);
  const [showResult, setShowResult] = useState(false);

  const [finalXi, setFinalXi] = useState([]);
  const [user, setUser] = useState(undefined);
  useEffect(() => { auth.ensure().then(setUser).catch(() => setUser(null)); }, []);

  const handleSim = (res, xi) => {
    setResult(res);
    setFinalXi(xi || []);
    setShowResult(true);
  };

  const reset = () => {
    setBoardKey((k) => k + 1);
    setResult(null);
    setShowResult(false);
  };

  return (
    <div className="bg-app min-h-screen text-white">
      {/* top bar */}
      <div className="sticky top-0 z-40 bg-[#0F172A]/85 backdrop-blur-md border-b border-white/5">
        <div className="max-w-5xl mx-auto px-4 h-14 flex items-center justify-between">
          <button
            onClick={() => navigate("/")}
            className="pill-nav rounded-full px-3.5 py-1.5 flex items-center gap-2 text-sm font-medium text-slate-200"
          >
            <ArrowLeft className="w-4 h-4" /> Back
          </button>
          <div className="font-display font-extrabold text-base sm:text-lg flex items-center gap-1.5 tracking-tight">
            <Swords className="w-4 h-4 text-[#10B981]" />
            <span className="text-white">FOOTIE</span>
            <span className="text-[#38BDF8]">CLASH</span>
          </div>
          <button
            onClick={reset}
            className="pill-nav rounded-full px-3.5 py-1.5 flex items-center gap-2 text-sm font-medium text-slate-200"
          >
            <RotateCcw className="w-4 h-4" /> Reset
          </button>
        </div>
      </div>

      {user === null ? (
        <div className="max-w-md mx-auto px-5 py-10"><AuthForm onAuthed={setUser} /></div>
      ) : (
        <DraftBoard key={boardKey} onSimulate={handleSim} />
      )}

      <SeasonResult open={showResult} result={result} xi={finalXi} onClose={() => setShowResult(false)} onReset={reset} />
      <Toaster />
    </div>
  );
};

export default Game;
